import { ServicesContext } from 'contexts/ServicesContext';
import { useContextStrict } from 'hooks/useContextStrict';

export const useServices = () => {
  return useContextStrict(ServicesContext);
};
